module.exports = __webpack_public_path__ + "img/1af7860.svg";